<template>
	<input-text 
		v-model="text" 
		:type="visible ? 'text' : 'password'" 
		:label="label" 
		:disabled="disabled"
		:errors="errors" 
		:append-icon="visible ? 'tools/design/hide' : 'tools/design/view'"
		:prepend-icon="prependIcon"
		@click:append="visible = !visible"
	></input-text>
</template>

<script>
	export default {
		props: ['label', 'errors', 'value', 'prependIcon', 'disabled', 'endpoint'],
		data(){
			return {
				visible: false,
				text: this.value
			};
		},
		watch: {
			text() {
				this.$emit('input', this.text);
			},
			value(){
				this.text = this.value;
				if(this.text === '••••••••') {
					this.visible = false;
				}
			},
			async visible() {
				if(this.visible && this.text === '••••••••') {
					this.text = await this.$decrypt(this.endpoint);
				}
			}
		}
	}
</script>